import { Navigation, PhoneBtn } from ".";
import { Link } from "react-router-dom";
import { SocialIcons } from "../components";
import logo from "../assets/compass-logo.png";

const year = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer>
      <img
        src={logo}
        className="logo"
        alt="Compass Glass - Architectural Glazing"
      />
      <Navigation />
      <PhoneBtn />
      <SocialIcons />
      <p className="copyright">
        &copy; {year} Compass Glass - Architectural Glazing. All Rights
        Reserved. <Link to="/privacy-policy">Privacy Policy</Link> | Built by{" "}
        <a href="https://craftandcode.io" target="_blank" rel="noreferrer">
          Craft & Code, LLC
        </a>
        .
      </p>
    </footer>
  );
};
